import './PostContentToolbar.scss';
import React from 'react';
import Icon from '../../../../elements/icons/Icon';
import UploadButton from './UploadButton';
import generateThumbnail from '../../../../../misc/generateThumbnail';

export default class PostContentToolbar extends React.Component {
    render() {
        let {color} = this.props;

        return (
            <div className="PostContentToolbar graybg">
                <div className="content">
                    {this.props.photoUploadEnabled ? (
                        <UploadButton icon="/img/post-photo.png" color={color} accept="image/*" onFilesSelected={this.props.onFilesSelected} />
                    ) : null}
                    {this.props.videoUploadEnabled ? (
                        <UploadButton icon="/img/post-video.png" color={color} accept="video/*" onFilesSelected={this.handleVideoFilesSelected.bind(this)} />
                    ) : null}
                    <button type="submit" disabled={this.props.disableSubmit} style={{backgroundColor: color}} />
                    {this.props.allowDelete ? (
                        <button type="button" className="pull-right" onClick={this.props.onDelete}>
                            <Icon src="/img/delete_item_outline_white.png" color="red" />
                        </button>
                    ) : null}
                </div>
            </div>
        );
    }
    async handleVideoFilesSelected(files) {
        let validFiles = [];
        for (let file of files) {
            try {
                let thumb = await generateThumbnail(file);
                validFiles.push(file);
            } catch (err) {
                console.error(err);
            }
        }
        this.props.onFilesSelected(validFiles);
    }
}
